// ---------------------------------------------------------------------------
// Export helpers
// ---------------------------------------------------------------------------
export function exportCSV(columns, rows, filename = 'export.csv') {
  const header = columns.join(',');
  const lines = rows.map((r) =>
    columns.map((c) => `"${String(r[c] || '').replace(/"/g, '""')}"`).join(',')
  );
  const blob = new Blob([header + '\n' + lines.join('\n')], { type: 'text/csv' });
  downloadBlob(blob, filename);
}
export function exportJSON(columns, rows, filename = 'export.json') {
  const blob = new Blob([JSON.stringify(rows, null, 2)], { type: 'application/json' });
  downloadBlob(blob, filename);
}
export function downloadBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
